<template>
    <section class="client-settings--ui">
        <LogoSettings />
        <FooterSettings />
        <UiElementSettings />
    </section>
</template>
<script charset="utf-8">
import LogoSettings from "./Parts/LogoSettings.vue"
import FooterSettings from "./Parts/FooterSettings.vue"
import UiElementSettings from "./Parts/UiElementSettings.vue";
export default {
    name: "ClientSettingsUI",
    components: {
        LogoSettings,
        FooterSettings,
        UiElementSettings
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
.client-settings--ui {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    row-gap: 20px;
    column-gap: 20px;
}
</style>